import styled from 'styled-components'
import media from 'styled-media-query'

export const InputContainer = styled.div`
  margin: 36px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;

  ${media.lessThan('medium')`
    padding: 0 12px;
    grid-template-columns: repeat(2, 1fr);

    .button-save-password {
      > svg {
        display: none;
      }
    }
  `}

  ${media.lessThan('small')`
    padding: 0 20px;
    grid-template-columns: repeat(1, 1fr);
  `}
`
